/* ============================================================
   IMENHOF BLOOM — theme.js (globale kern)
   Alleen wat op elke pagina nodig is: drawers, scroll-lock,
   sticky header, meldingen, winkelwagen (drawer + add + kaart-
   quickadd). Productgalerij/variantkiezer staan in product.js
   (alleen productpagina). Filteren/oneindig laden in refine.js
   (collectie + zoeken).
   ============================================================ */
(function () {
  'use strict';
  document.documentElement.classList.add('js');
  const money = (cents) => window.Shopify && Shopify.formatMoney
    ? Shopify.formatMoney(cents, window.themeMoneyFormat)
    : '€' + (cents / 100).toFixed(2).replace('.', ',');

  const escapeHtml = (value) => String(value == null ? '' : value).replace(/[&<>"']/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  })[char]);
  const focusSafe = (element) => {
    if (!element || !element.focus) return;
    try { element.focus({ preventScroll: true }); } catch (_) { element.focus(); }
  };
  const announce = (message) => {
    if (message && window.IMHAnnounce) window.IMHAnnounce(message);
  };

  /* ---------- Toast ---------- */
  let toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      document.body.appendChild(toastEl);
    }
    const icon = document.createElement('span');
    icon.textContent = '✓';
    toastEl.replaceChildren(icon, document.createTextNode(String(msg || '')));
    toastEl.classList.add('is-show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-show'), 2600);
  }

  /* ---------- Scroll lock (iOS-proof) ----------
     body{overflow:hidden} wordt door iOS Safari genegeerd;
     position:fixed met scrollpositie-herstel werkt overal. */
  let lockY = 0;
  let isLocked = false;
  function lockScroll() {
    if (isLocked) return;
    lockY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = (-lockY) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    isLocked = true;
  }
  function unlockScroll() {
    if (!isLocked) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    isLocked = false;
    const prev = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, lockY);
    document.documentElement.style.scrollBehavior = prev;
  }

  /* ---------- Drawer controller ---------- */
  function openDrawer(el, opener) {
    if (!el) return;
    if (opener && opener.focus) el._imhOpener = opener;
    el.classList.add('is-open');
    lockScroll();
    // Beginfocus meteen binnen dezelfde gebruikersactie zetten. Dat voorkomt
    // dat de zojuist inert gemaakte opener de focus tijdelijk naar body duwt.
    // Forceer eerst de nieuwe visibility-stijl, anders kan een browser het
    // doel nog als verborgen behandelen op het moment van focus().
    void el.offsetWidth;
    focusSafe(el.querySelector('[data-drawer-initial-focus],input,button,a'));
    // a11y-drawers.js zet de beginfocus direct. Dit is alleen een vangnet:
    // trek de focus na 300 ms niet terug als de bezoeker al verder heeft getabd.
    setTimeout(() => {
      if (!el.classList.contains('is-open') || el.contains(document.activeElement)) return;
      focusSafe(el.querySelector('[data-drawer-initial-focus],input,button,a'));
    }, 300);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    if (!document.querySelector('.drawer.is-open')) unlockScroll();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')), opener);
    }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__overlay')) {
      const d = e.target.closest('.drawer');
      if (d) closeDrawer(d);
    }
  });
  document.addEventListener('keydown', (e) => {
    const opener = e.target.closest && e.target.closest('[data-drawer-open]');
    if (opener && !e.repeat && (e.key === 'Enter' || e.key === ' ')) {
      // Voorkom dat de standaard knop-click na openen de focus alsnog naar
      // de inmiddels inert gemaakte trigger terugtrekt.
      e.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')), opener);
      return;
    }
    if (e.key === 'Escape') document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
  });
  if (document.querySelector('.drawer.is-open')) lockScroll();

  /* ---------- Sticky header on scroll ---------- */
  const header = document.querySelector('.header-wrap');
  if (header) {
    let last = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 8);
      last = y;
    }, { passive: true });
  }

  /* ---------- Announcement rotation ---------- */
  document.querySelectorAll('[data-announce]').forEach((box) => {
    const items = box.querySelectorAll('.announce__item');
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  });

  /* ---------- Reveal on scroll ----------
     rootMargin van 200px onder de viewport: elementen beginnen hun fade-in
     vóórdat ze in beeld komen, zodat je bij het scrollen nooit tegen een
     leeg vlak aankijkt. threshold laag houden — anders wacht de animatie
     tot een fors deel van de sectie zichtbaar is. */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.01, rootMargin: '0px 0px 200px 0px' });
    document.querySelectorAll('.reveal').forEach((el) => io.observe(el));
  } else {
    document.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-in'));
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.qty button');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input');
    let val = parseInt(input.value, 10) || 0;
    val += btn.dataset.dir === 'up' ? 1 : -1;
    if (val < parseInt(input.min || 0, 10)) val = parseInt(input.min || 0, 10);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ============================================================
     CART
     ============================================================ */
  const cartDrawer = document.getElementById('CartDrawer');

  async function fetchCart() {
    const r = await fetch('/cart.js');
    return r.json();
  }
  function renderCart(cart) {
    const body = document.getElementById('CartDrawerBody');
    const foot = document.getElementById('CartDrawerFoot');
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
      const button = el.closest('[data-drawer-open="CartDrawer"]');
      if (button) button.setAttribute('aria-label', 'Winkelwagen, ' + cart.item_count + (cart.item_count === 1 ? ' artikel' : ' artikelen'));
    });
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><div class="cart-empty__icon">🪴</div><h3>Je winkelwagen is leeg</h3><p>Ontdek onze planten en voeg je favorieten toe.</p><a class="btn" href="/collections/all" data-drawer-close>Bekijk planten</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    const threshold = parseInt(body.dataset.freeShip || 0, 10);
    const localThreshold = parseInt(body.dataset.localThreshold || 0, 10);
    const localRadius = parseInt(body.dataset.localRadius || 10, 10);
    let progress = '';
    if (threshold > 0) {
      const localPending = localThreshold > 0 && cart.total_price < localThreshold;
      const target = localPending ? localThreshold : threshold;
      const pct = Math.min(100, (cart.total_price / target) * 100);
      const remain = threshold - cart.total_price;
      const localRemain = localThreshold - cart.total_price;
      let progressMessage = '';
      if (localPending) {
        progressMessage = 'Nog ' + money(localRemain) + ' tot lokale bezorging binnen ' + localRadius + ' km 🌿';
      } else if (remain > 0) {
        progressMessage = 'Lokale bezorging binnen ' + localRadius + ' km is beschikbaar. Nog ' + money(remain) + ' tot bezorging buiten ' + localRadius + ' km 🌿';
      } else {
        progressMessage = 'Je komt in aanmerking voor bezorging aan huis 🌿';
      }
      progress = '<div class="cart-progress"><div class="cart-progress__bar"><div class="cart-progress__fill" style="width:' + pct + '%"></div></div><p>' + progressMessage + '</p></div>';
    }
    body.innerHTML = progress + cart.items.map((it) => {
      const title = String(it.product_title || 'Product');
      const safeTitle = escapeHtml(title);
      const img = it.image ? '<img src="' + escapeHtml(it.image.replace(/(\.[^.]+)$/, '_160x$1')) + '" alt="" width="74" height="74">' : '<div style="width:74px;height:74px;border-radius:10px;background:var(--surface-2)"></div>';
      const variant = (it.product_has_only_default_variant) ? '' : '<p class="cart-line__variant">' + escapeHtml(it.variant_title) + '</p>';
      return '<div class="cart-line" data-key="' + escapeHtml(it.key) + '">' + img +
        '<div><a href="' + escapeHtml(it.url) + '" class="cart-line__title">' + safeTitle + '</a>' + variant +
        '<div class="qty qty--sm" role="group" aria-label="Aantal van ' + safeTitle + '"><button type="button" data-cart-minus aria-label="Eén minder van ' + safeTitle + '">−</button><input type="text" value="' + it.quantity + '" data-cart-qty readonly aria-label="Aantal van ' + safeTitle + '"><button type="button" data-cart-plus aria-label="Eén meer van ' + safeTitle + '">+</button></div>' +
        '<button type="button" class="cart-line__remove" data-cart-remove aria-label="Verwijder ' + safeTitle + '">Verwijderen</button></div>' +
        '<div class="cart-line__price">' + money(it.final_line_price) + '</div></div>';
    }).join('');
    if (foot) {
      foot.querySelector('[data-cart-total]').textContent = money(cart.total_price);
    }
  }

  async function changeLine(key, qty) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    return r.json();
  }

  function cartLineByKey(key) {
    return Array.from(document.querySelectorAll('#CartDrawerBody .cart-line[data-key]'))
      .find((candidate) => candidate.dataset.key === key) || null;
  }

  if (cartDrawer) {
    cartDrawer.addEventListener('click', async (e) => {
      const line = e.target.closest('.cart-line');
      if (!line) return;
      const key = line.dataset.key;
      const qtyEl = line.querySelector('[data-cart-qty]');
      if (!qtyEl) return;
      const title = (line.querySelector('.cart-line__title') || {}).textContent || 'Product';
      const nextLine = line.nextElementSibling && line.nextElementSibling.matches('.cart-line')
        ? line.nextElementSibling
        : (line.previousElementSibling && line.previousElementSibling.matches('.cart-line') ? line.previousElementSibling : null);
      const fallbackKey = nextLine ? nextLine.dataset.key : '';
      const plus = e.target.closest('[data-cart-plus]');
      const minus = e.target.closest('[data-cart-minus]');
      const remove = e.target.closest('[data-cart-remove]');
      let qty = parseInt(qtyEl.value, 10);
      if (plus) qty += 1;
      else if (minus) qty -= 1;
      else if (remove) qty = 0;
      else return;
      line.style.opacity = '.5';
      line.setAttribute('aria-busy', 'true');
      try {
        const cart = await changeLine(key, Math.max(0, qty));
        const item = cart.items.find((candidate) => candidate.key === key);
        renderCart(cart);
        const freshLine = item ? cartLineByKey(key) : (fallbackKey ? cartLineByKey(fallbackKey) : null);
        const focusTarget = item
          ? freshLine && freshLine.querySelector(plus ? '[data-cart-plus]' : (minus ? '[data-cart-minus]' : '[data-cart-remove]'))
          : ((freshLine && freshLine.querySelector('button, a[href], input')) || document.querySelector('#CartDrawerBody .cart-empty a, #CartDrawer [data-drawer-close]'));
        focusSafe(focusTarget);
        announce(item
          ? title.trim() + ': aantal ' + item.quantity + '. Subtotaal ' + money(cart.total_price) + '.'
          : title.trim() + ' verwijderd uit de winkelwagen.');
      } catch (_) {
        line.style.opacity = '';
        line.removeAttribute('aria-busy');
        toast('Kon de winkelwagen niet bijwerken');
      }
    });
  }

  /* ---------- Add to cart (forms + quick add) ---------- */
  async function addToCart(formData) {
    const r = await fetch('/cart/add.js', { method: 'POST', body: formData });
    if (!r.ok) { const err = await r.json(); throw new Error(err.description || 'Er ging iets mis'); }
    return r.json();
  }
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form], [data-quick-add]');
    if (!form) return;
    e.preventDefault();
    if (form.dataset.submitting === 'true') return;
    const submitSource = e.submitter || form.querySelector('[type=submit]');
    const productTitle = ((form.closest('[data-product-section], .pcard') || document).querySelector('.product__title, .pcard__title') || {}).textContent;
    form.dataset.submitting = 'true';
    const relatedSubmits = [form.querySelector('[type=submit]'), e.submitter];
    if (form.id) {
      relatedSubmits.push(document.querySelector(`[data-buybar-add][form="${CSS.escape(form.id)}"]`));
    }
    const submitStates = [...new Set(relatedSubmits.filter(Boolean))].map((button) => ({
      button,
      html: button.innerHTML,
      disabled: button.disabled
    }));
    submitStates.forEach(({ button }) => {
      button.disabled = true;
      button.innerHTML = 'Bezig…';
    });
    window.dispatchEvent(new CustomEvent('imenhof:product-submit-state', { detail: { form, submitting: true } }));
    try {
      await addToCart(new FormData(form));
      const cart = await fetchCart();
      renderCart(cart);
      openDrawer(cartDrawer, submitSource);
      toast((productTitle ? productTitle.trim() + ' ' : '') + 'toegevoegd aan winkelwagen');
    } catch (err) {
      toast(err.message);
    } finally {
      delete form.dataset.submitting;
      window.dispatchEvent(new CustomEvent('imenhof:product-submit-state', { detail: { form, submitting: false } }));
      submitStates.forEach(({ button, html, disabled }) => {
        if (!button.isConnected || button.textContent.trim() !== 'Bezig…') return;
        button.disabled = disabled;
        button.innerHTML = html;
      });
    }
  });

  /* ---------- Kaart: quick-add onder de prijs + inline aantal-stepper ----------
     Eigen class 'pcard__stepper' (niet '.qty'), zodat de generieke
     qty-handler hierboven er niet op vuurt. Hergebruikt addToCart/fetchCart/
     renderCart/toast, zodat de winkelwagen-drawer netjes meeloopt. */
  function cardProductTitle(element) {
    const card = element && element.closest('.pcard');
    const title = card && card.querySelector('.pcard__title');
    return (title && title.textContent.trim()) || 'dit product';
  }
  function cardStepperHTML(id, qty, title) {
    const safeTitle = escapeHtml(title);
    return '<div class="pcard__stepper" data-card-qty data-variant-id="' + escapeHtml(id) + '" data-product-title="' + safeTitle + '" role="group" aria-label="Aantal van ' + safeTitle + '">' +
      '<button type="button" data-card-minus aria-label="Eén minder van ' + safeTitle + '">−</button>' +
      '<input type="text" value="' + qty + '" data-card-qtyval readonly aria-label="Aantal van ' + safeTitle + '">' +
      '<button type="button" data-card-plus aria-label="Eén meer van ' + safeTitle + '">+</button></div>';
  }
  function cardAddBtnHTML(id, title) {
    const safeTitle = escapeHtml(title);
    return '<button type="button" class="btn btn--secondary btn--full btn--sm pcard__addbtn" data-card-add data-variant-id="' + escapeHtml(id) + '" aria-label="Voeg ' + safeTitle + ' toe aan de winkelwagen">In winkelmand</button>';
  }
  async function cartChangeById(id, quantity) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(id), quantity: quantity })
    });
    return r.json();
  }
  function cardLineQty(cart, id) {
    const line = cart.items.find((it) => String(it.variant_id) === String(id));
    return line ? line.quantity : 0;
  }
  document.addEventListener('click', async (e) => {
    const add = e.target.closest('[data-card-add]');
    if (add) {
      e.preventDefault();
      if (add.disabled || add.dataset.busy) return;
      const wrap = add.closest('[data-card-add-wrap]');
      const id = add.dataset.variantId;
      const title = cardProductTitle(add);
      const orig = add.innerHTML;
      add.dataset.busy = '1';
      add.setAttribute('aria-busy', 'true');
      add.setAttribute('aria-disabled', 'true');
      add.innerHTML = 'Bezig…';
      try {
        const fd = new FormData();
        fd.append('id', id);
        fd.append('quantity', 1);
        await addToCart(fd);
        const cart = await fetchCart();
        renderCart(cart);
        if (wrap) {
          wrap.dataset.productTitle = title;
          wrap.innerHTML = cardStepperHTML(id, cardLineQty(cart, id) || 1, title);
          focusSafe(wrap.querySelector('[data-card-plus]'));
        }
        toast(title + ' toegevoegd aan winkelwagen');
      } catch (err) {
        delete add.dataset.busy;
        add.removeAttribute('aria-busy');
        add.removeAttribute('aria-disabled');
        add.innerHTML = orig;
        toast(err.message || 'Er ging iets mis');
      }
      return;
    }
    const step = e.target.closest('[data-card-qty] [data-card-plus], [data-card-qty] [data-card-minus]');
    if (step) {
      const box = step.closest('[data-card-qty]');
      if (box.dataset.busy) return;
      const wrap = box.closest('[data-card-add-wrap]');
      const id = box.dataset.variantId;
      const title = box.dataset.productTitle || (wrap && wrap.dataset.productTitle) || cardProductTitle(box);
      const input = box.querySelector('[data-card-qtyval]');
      let next = (parseInt(input.value, 10) || 0) + (step.hasAttribute('data-card-plus') ? 1 : -1);
      if (next < 0) next = 0;
      box.dataset.busy = '1';
      box.setAttribute('aria-busy', 'true');
      box.style.opacity = '.6';
      try {
        const cart = await cartChangeById(id, next);
        renderCart(cart);
        const q = cardLineQty(cart, id);
        if (q <= 0) {
          if (wrap) {
            wrap.innerHTML = cardAddBtnHTML(id, title);
            focusSafe(wrap.querySelector('[data-card-add]'));
          }
        } else {
          input.value = q;
          box.style.opacity = '';
          delete box.dataset.busy;
          box.removeAttribute('aria-busy');
        }
        announce(title + ': aantal ' + q + ' in de winkelwagen.');
      } catch (err) {
        box.style.opacity = '';
        delete box.dataset.busy;
        box.removeAttribute('aria-busy');
        toast('Kon winkelwagen niet bijwerken');
      }
      return;
    }
  });

  /* ---------- Initial cart sync ---------- */
  fetchCart().then(renderCart).catch(() => {});
})();
